<template>
  <page-list
    :list="list"
    :columns="columns"
    :export-data-options="exportDataOptions"
    :group-actions="groupActions"
    :placeholder="$t('common.default_search_key',['平台'])" />
</template>

<script>
import WindowsMixin from '@/mixins/windows'
import ListMixin from '@/mixins/list'
import { getTimeRangeFilter } from '@/utils/common/tableFilter'
import { getTimeTableColumn } from '@/utils/common/tableColumn'

export default {
  name: 'OperationRecordsList',
  mixins: [WindowsMixin, ListMixin],
  props: {
    id: String,
  },
  data () {
    return {
      list: this.$list.createList(this, {
        id: this.id,
        resource: 'operation_records',
        apiVersion: 'v1',
        getParams: this.getParam,
        filterOptions: {
          record_at: getTimeRangeFilter({ field: 'record_at', label: '日期' }),
        },
      }),
      groupActions: [
        {
          label: this.$t('common.create'),
          permission: 'operation_records_create',
          action: () => {
            this.createDialog('OperationRecordCreateDialog', {
              title: this.$t('common_628', [this.$t('scope.operation_records_list')]),
              onManager: this.onManager,
              refresh: this.refresh,
            })
          },
          meta: () => {
            return {
              buttonType: 'primary',
            }
          },
        },
      ],
      columns: [
        getTimeTableColumn({
          field: 'record_at',
          title: '日期',
          minWidth: 100,
          format: 'YYYY-MM-DD',
        }),
        {
          field: 'user3_days',
          title: '用户数',
          slots: {
            default: ({ row }) => {
              return [
                <div>3天: {row.user3_days}</div>,
                <div>30天：{row.user30_days}</div>,
              ]
            },
          },
        },
        {
          field: 'active_user3_days',
          title: '活跃用户数',
          slots: {
            default: ({ row }) => {
              return [
                <div>3天: {row.active_user3_days}</div>,
                <div>30天：{row.active_user30_days}</div>,
              ]
            },
          },
        },
        {
          field: 'kvm3_days',
          title: 'KVM主机数',
          slots: {
            default: ({ row }) => {
              return [
                <div>3天: {row.kvm3_days}</div>,
                <div>30天：{row.kvm30_days}</div>,
              ]
            },
          },
        },
        {
          field: 'vm3_days',
          title: '虚机数',
          slots: {
            default: ({ row }) => {
              return [
                <div>3天: {row.vm3_days}</div>,
                <div>30天：{row.vm30_days}</div>,
              ]
            },
          },
        },
        {
          field: 'baremetal3_days',
          title: '裸金属数',
          slots: {
            default: ({ row }) => {
              return [
                <div>3天: {row.baremetal3_days}</div>,
                <div>30天：{row.baremetal30_days}</div>,
              ]
            },
          },
        },
        {
          field: 'github_stars',
          title: 'GITHUB',
        },
        {
          field: 'portal_users',
          title: '注册用户',
        },
        {
          field: 'license_count',
          title: '授权数',
          slots: {
            default: ({ row }) => {
              return [
                <div>有效: {row.valid_license_count}</div>,
                <div>累计：{row.license_count}</div>,
              ]
            },
          },
        },
        {
          field: 'saas_servers',
          title: 'SaaS',
          slots: {
            default: ({ row }) => {
              return [
                <div>主机: {row.saas_servers}</div>,
                <div>云账号：{row.saas_accounts}</div>,
              ]
            },
          },
        },
        {
          field: 'group_users',
          title: '微信群用户数',
          slots: {
            default: ({ row }) => {
              const tips = []
              let total = 0
              for (let i = 0; i < row.group_users.length; i++) {
                tips.push('' + (i + 1) + '群' + row.group_users[i] + '人')
                total += row.group_users[i]
              }
              return [
                <a-tooltip class="ml-1" title={tips.join(',')}>{'' + total + '人(' + row.group_users.length + '群)'}</a-tooltip>,
              ]
            },
          },
        },
        {
          field: 'wechat_followers',
          title: '公众号',
          slots: {
            default: ({ row }) => {
              return [
                <div>{row.wechat_followers}</div>,
              ]
            },
          },
        },
      ],
    }
  },
  computed: {
    exportDataOptions () {
      return {
        title: '开源用户统计',
        downloadType: 'local',
        items: [
          ...this.columns,
          {
            field: 'country',
            title: '地址',
            formatter: ({ row }) => {
              let str = ''
              if (row.country) str += row.country
              if (row.prov) str += str ? `, ${row.prov}` : row.prov
              if (row.city) str += str ? `, ${row.city}` : row.city
              if (row.isp) str += str ? `(${row.isp})` : row.isp
              return str
            },
          },
        ],
      }
    },
  },
  watch: {
    selectedDay () {
      this.list.fetchData()
    },
    dayType: {
      immediate: true,
      handler (val) {
        if (val) {
          this.selectedDay = val
        }
      },
    },
  },
  created () {
    this.list.fetchData()
  },
  activated () {
    this.selectedDay = this.dayType
  },
  methods: {
    getParam () {
      const ret = {
        details: true,
      }
      if (this.selectedDay !== 'all') {
        ret.filter = `updated_at.ge("${this.$moment().utc().subtract(this.selectedDay, 'day').format('YYYY-MM-DD HH:mm:ss')}")`
      }
      return ret
    },
  },
}
</script>
